import { render, staticRenderFns } from "./Page2Pdf1.vue?vue&type=template&id=5b1a870a&scoped=true&"
import script from "./Page2Pdf1.vue?vue&type=script&lang=js&"
export * from "./Page2Pdf1.vue?vue&type=script&lang=js&"
import style0 from "./Page2Pdf1.vue?vue&type=style&index=0&id=5b1a870a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a870a",
  null
  
)

export default component.exports